const EDBUY_URL =
  "https://education.nsw.gov.au/inside-the-department/teaching-and-learning/marketplace/online-learning-tools-marketplace/product-catalogue";

/**
 * Shown on the direct order page in place of the product picker AND the cart when
 * an NSW & ACT government school is selected: those schools order through the NSW
 * DoE EdBuy marketplace. Instructions only — nothing here launches or submits PunchOut.
 */
export function EdBuyInstructions() {
  return (
    <section className="edbuy-card" aria-labelledby="edbuy-heading">
      <h2 id="edbuy-heading" className="edbuy-heading">Order through NSW DoE EdBuy</h2>
      <ol className="edbuy-steps">
        <li className="edbuy-step">
          <span className="edbuy-step-number" aria-hidden="true">1</span>
          <div className="edbuy-step-body">
            <p>
              Order via{" "}
              <a href={EDBUY_URL} target="_blank" rel="noopener noreferrer" className="edbuy-link-strong">
                NSW DoE EdBuy purchasing platform
              </a>
              , view and click on supplier SmarterEd (which will take you to a special DoE integrated version of
              this ordering page).
            </p>
            <p>
              <a href={EDBUY_URL} target="_blank" rel="noopener noreferrer" className="edbuy-link-url">
                {EDBUY_URL}
              </a>
            </p>
          </div>
        </li>
        <li className="edbuy-step">
          <span className="edbuy-step-number" aria-hidden="true">2</span>
          <div className="edbuy-step-body">
            <p>
              Choose your courses and the number of teacher licences for each course and <strong>Add to cart</strong>.
              Then click <strong>Proceed</strong> to complete the order in EdBuy.
            </p>
          </div>
        </li>
        <li className="edbuy-step">
          <span className="edbuy-step-number" aria-hidden="true">3</span>
          <div className="edbuy-step-body">
            <p>
              When the order is confirmed, EdBuy issues an “EB” number (purchase order) for the school to “receive”
              and EdBuy to remit payment.
            </p>
          </div>
        </li>
      </ol>
    </section>
  );
}
